import { useState } from 'react';
import { PaymentMethod } from '@frontend/api-payment-plans';
import { contextFactory } from '@frontend/design-system';
import { PaymentMethodsStateContext, PaymentMethodsView } from '../types/provider.types';

export const [PaymentMethodsState, usePaymentMethodsStateContext] = contextFactory<PaymentMethodsStateContext>(
  '',
  {} as PaymentMethodsStateContext
);

export type PaymentMethodsStateProviderProps = React.PropsWithChildren<object>;
export const PaymentMethodsStateProvider = ({ children }: PaymentMethodsStateProviderProps) => {
  const [view, setView] = useState<PaymentMethodsView>('list');
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<PaymentMethod | null>(null);
  const [isResendVerificationAchMode, setIsResendVerificationAchMode] = useState(false);

  return (
    <PaymentMethodsState.Provider
      value={{
        view,
        setView,
        selectedPaymentMethod,
        setSelectedPaymentMethod,
        isResendVerificationAchMode,
        setIsResendVerificationAchMode,
      }}
    >
      {children}
    </PaymentMethodsState.Provider>
  );
};
